import { render, staticRenderFns } from "./FeedbacksSection.v2.vue?vue&type=template&id=51cdad54&scoped=true"
import script from "./FeedbacksSection.v2.vue?vue&type=script&lang=js"
export * from "./FeedbacksSection.v2.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksSection.v2.vue?vue&type=style&index=0&id=51cdad54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdad54",
  null
  
)

export default component.exports